<template>
  <div>
    <div class="is-flex is-justify-content-flex-end">
      <a @click="vested" class="button is-info">Vested</a>
    </div>
    <div v-if="form">
      <div>
        <p><b>status</b></p>
        <select v-model="form.data.offer.fields.status.value" dir="rtl">
          <option
            :key="status.id"
            v-for="status in getAllStatuses"
            >{{ status.name }}</option
          >
        </select>
      </div>
      <div>
        <p><b>message</b></p>
        <textarea
          placeholder="Message"
          v-model="form.data.offer.fields.message.value"
        ></textarea>
      </div>
      <div>
        <p class="bold">owner</p>
        <input
          v-model="form.data.offer.fields.owner.value"
          class="outlined"
          placeholder="owner"
        />
      </div>
    </div>
    <div class="modal_footer">
      <a
        @click="submit()"
        :class="{ 'is-loading': is_loading }"
        class="button is-info"
        >Submit</a
      >
    </div>
  </div>
</template>
<script>
import { mapMutations, mapGetters } from 'vuex'
import OffersHelper from '@/custom/classes/offers_helper.js'
export default {
  props: ['payload'],
  name: 'admin-offers-form',
  data () {
    return {
      offers_helper: new OffersHelper(),
      is_loading: false,
      form: undefined
    }
  },
  computed: {
    ...mapGetters('offerStatuses', ['getAllStatuses', 'getGreenList'])
  },
  created () {
    this.init()
  },
  methods: {
    init () {
      this.$network_utils.getResourceOffer({ offer_id: this.payload.data.id }).then(response => {
        this.setForm(response)
      })
    },
    setForm (form_data) {
      this.form = new this.$form({
        offer: {
          fields: {
            status: {
              value: form_data.status.name,
              has_error: false,
              validations: []
            },
            message: {
              value: form_data.message,
              has_error: false,
              validations: []
            },
            owner: {
              value: form_data.owner,
              has_error: false,
              validations: []
            },
            id: {
              value: form_data.id,
              has_error: false,
              validations: []
            }
          },
          request_details: {
            method: 'put',
            url: '/offers/' + form_data.id,
            headers: 'admin_headers'
          },
          is_used: true
        }
      })
    },
    submit () {
      if (this.payload.data.status.color == 'red' && this.getGreenList.map(s => s.name).includes(this.form.data.offer.fields.status.value)) {
        this.$network_utils.postAlert({
          designator: 'send_cv',
          resource_type: 'Applicant',
          resource_id: this.payload.data.applicant.id,
          minimum_permission: 1,
          maximum_permission: 6
        })
      }
      let response = this.form.mySubmit()
      if (response === false) {
        return
      }
      const messageFooter = '<messsage-meta><message-date>' + new Date() + '</message-date><owner>' + this.$utils.getOwner().name + '</owner></messsage-meta>'
      this.offers_helper.changeOfferStatus({
        offer: this.payload.data,
        new_data: { status: this.form.data.offer.fields.status.value, message: `${this.form.data.offer.fields.message.value}\n\n${messageFooter}` }
      })
      this.is_loading = true
      response.promise.then((response) => {
        this.is_loading = false
        this.$utils.emit('show_toast', { text: 'success' })
        this.remove(this.payload)
      })
    },
    vested () {
      this.create({ designator: 'vested-confirmation-modal', component_name: 'VestedConfirmationForm', data: this.payload.data, modal_title: 'Vested' })
    },
    ...mapMutations('modals', ['create', 'remove'])
  }
}
</script>
